import script from "./UtmPopularEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./UtmPopularEvents.vue?vue&type=script&setup=true&lang=js"

import "./UtmPopularEvents.vue?vue&type=style&index=0&id=6d373bab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d373bab"]])

export default __exports__